/**
 * Extrai mensagem legível de respostas de erro da API (RFC 7807 / Nest problem details, etc.).
 */
export function getApiErrorMessage(data: unknown, fallback: string): string {
  if (!data || typeof data !== 'object') {
    return fallback;
  }

  const obj = data as Record<string, unknown>;

  const detail = typeof obj.detail === 'string' && obj.detail.trim();
  if (detail) return detail;

  const message = typeof obj.message === 'string' && obj.message.trim();
  if (message) return message;

  const error = typeof obj.error === 'string' && obj.error.trim();
  if (error) return error;

  const title = typeof obj.title === 'string' && obj.title.trim();
  if (title && title !== 'Bad Request' && title !== 'Unauthorized') {
    return title;
  }

  return fallback;
}

/**
 * Status HTTP carimbado no erro pelas mutations (`Object.assign(new Error(...),
 * { statusCode })`). É o que distingue, por exemplo, um 409 de "assinatura já
 * em andamento" de uma falha real ao iniciar a assinatura.
 */
export function getErrorStatusCode(error: unknown): number | undefined {
  if (error && typeof error === 'object' && 'statusCode' in error) {
    const code = (error as { statusCode?: unknown }).statusCode;
    return typeof code === 'number' ? code : undefined;
  }
  return undefined;
}
